import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateRangeText',
})
export class DateRangeTextPipe implements PipeTransform {
  transform(value: Date[] | null): string {
    if (!value || value.length !== 2) {
      return 'Seleccionar rango de fechas';
    }
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
    const startDate = value[0].toLocaleDateString('es-PE', options);
    const endDate = value[1].toLocaleDateString('es-PE', options);
    return `${startDate} - ${endDate}`;
  }
}
